import React, { useEffect, useState } from "react";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useHomeState } from "../../_store/Home";
import {
  HomeFromProps,
  FindWithPhoneRequest,
  FindWithPhoneResponse,
  MasterRefCode,
  CreateTransClientRequest,
} from "../../_types/Home";
import Spinner from "../../components/spinners/Spinner";
import { useAuth } from "../../context/UseAuth";
import { useHelper } from "../../context/Helper";
import InputFieldComponent, {
  InputMode,
} from "../../components/common/InputField";
import { toast } from "react-toastify";
import JsonViewerComponent from "../../components/common/JsonViewerComponent";
import { Input, DatePicker } from "rsuite";
import moment from "moment-timezone";
import Select from "react-select";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import { add } from "lodash";

const validationRequestRegisterData = () => {
  return yup.object<HomeFromProps>({
    findWithPhoneRequest: yup.object<FindWithPhoneRequest>({
      phone: yup.string().required("กรุณาระบุข้อมูล"),
    }),
    createTransClientRequest: yup.object<CreateTransClientRequest>({
      dateOfBirth: yup.mixed().nullable().test(
        'dateOfBirth',
        'กรุณากรอกวันเกิด',
        function (value) {
          return value != null && value !== '';
        }
      ),
      receiveServiceDate: yup.mixed().nullable().test(
        'receiveServiceDate',
        'กรุณาเลือกวันที่นัดหมาย',
        function (value) {
          return value != null && value !== '';
        }
      ),
    }),
  });
};
const MySwal = withReactContent(Swal);

const ModalAddClient = ({
  isOpenPopupAddClient,
  setIsOpenPopupAddClient,
}: {
  isOpenPopupAddClient: boolean;
  setIsOpenPopupAddClient: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const isLoading = useHomeState((state) => state.isLoading);
  const setIsLoading = useHomeState((state) => state.setIsLoading);
  const verifyTelephone = useHomeState((state) => state.verifyTelephone);
  const verifyTelephoneWithCaseRegister = useHomeState(
    (state) => state.verifyTelephoneWithCaseRegister
  );
  const { getMessage } = useHelper();
  const { profile } = useAuth();
  const [isCreateClient, setIsCreateClient] = useState(false);
  const getTransSaleGroup = useHomeState((state) => state.getTransSaleGroup);
  const createTransClient = useHomeState((state) => state.createTransClient);
  const [ddlRefCode, setddlRefCode] = useState<OptionMultiLanguageProps[]>([]);
  const [isEditTel, setIsEditTel] = useState(false);

  const navigate = useNavigate();

  const methods = useForm<HomeFromProps>({
    mode: "onChange",
    resolver: yupResolver(validationRequestRegisterData()),
    defaultValues: undefined,
  });
  const {
    formState: { errors },
    reset,
    setValue,
    watch,
    trigger,
    resetField: resetFieldModal,
  } = methods;

  const verifyphone: SubmitHandler<HomeFromProps> = async (data) => {
    setIsLoading(true);
    const param = {
      code: "+66",
      phone: data.findWithPhoneRequest?.phone,
    } as FindWithPhoneRequest | undefined;
    await verifyTelephoneWithCaseRegister(param).then(
      async (res: ResponseProps) => {
        if (res.data?.code === 200) {
          if (res.data?.status === true) {
            var response = res.data.output.data as FindWithPhoneResponse;
            setIsCreateClient(true);
            if (response.isDuplicate) {
              await setValue(
                "createTransClientRequest.fullName",
                response.fullName
              );
              await setValue(
                "createTransClientRequest.dateOfBirth",
                response.dateOfBirth
              );
            }
            setIsEditTel(true);
            setIsLoading(false);
          } else {
            setIsLoading(false);
            toast.error(getMessage(res));
          }
        } else {
          setIsLoading(false);
          toast.error(getMessage(res));
        }
      }
    );
  };

  const getDropdown = async () => {
    const masterSaleGroupId =
      profile().masterSaleGroupId !== undefined
        ? profile().masterSaleGroupId?.toString()
        : "";
    await getTransSaleGroup(masterSaleGroupId).then(async (res) => {
      if (res.data?.code === 200) {
        if (res.data?.status === true) {
          var data = res.data?.output.data as MasterRefCode[];
          await setValue("masterRefCode", data);
          var ddl = data.map((a) => {
            return {
              value: a.refCode,
              labelTh: a.fullName,
              labelEn: a.fullName,
            } as OptionMultiLanguageProps;
          });
          setddlRefCode(ddl);
        } else {
          toast.error(getMessage(res));
        }
      } else {
        toast.error(getMessage(res));
      }
    });
  };

  const createClient: SubmitHandler<HomeFromProps> = async (data) => {
    const param = {
      dateOfBirth: data.createTransClientRequest?.dateOfBirth
        ? moment
          .tz(data.createTransClientRequest?.dateOfBirth, "Asia/Bangkok")
          .format("YYYY-MM-DD")
        : undefined,
      fullName: data.createTransClientRequest?.fullName,
      gestationalAge:
        data.createTransClientRequest?.gestationalAge !== ""
          ? data.createTransClientRequest?.gestationalAge
          : undefined,
      receiveServiceDate: data.createTransClientRequest?.receiveServiceDate
        ? moment
          .tz(
            data.createTransClientRequest?.receiveServiceDate,
            "Asia/Bangkok"
          )
          .format("YYYY-MM-DD")
        : undefined,
      saleRecord: data.createTransClientRequest?.saleRecord,
      telephoneNumber: data.findWithPhoneRequest?.phone,
      tranSaleRefCode: data.createTransClientRequest?.tranSaleRefCode,
    } as CreateTransClientRequest;

    await createTransClient(param).then(async (res) => {
      if (res.data?.code === 200) {
        if (res.data?.status === true) {
          var response = res.data.output.data as any;
          MySwal.fire({
            icon: "success",
            text: `บันทึกสำเร็จ`,
            confirmButtonText: "ตกลง",
            confirmButtonColor: "#3085d6",
            allowOutsideClick: false,
            allowEscapeKey: false,
          }).then(async (result) => {
            setIsOpenPopupAddClient(false);
            navigate(0);
          });
          setIsLoading(false);
        } else {
          setIsLoading(false);
          toast.error(getMessage(res));
        }
      } else {
        setIsLoading(false);
        // Handle validation errors (400 status) - check multiple possible error structures
        const errorData = res.data || res;
        if ((errorData as any)?.status === 400 || (errorData as any)?.code === 400) {
          const errors = (errorData as any)?.errors || (res as any)?.errors;
          if (errors) {
            const errorMessages = Object.keys(errors).map(field => {
              const messages = errors[field];
              return Array.isArray(messages) ? messages.join(', ') : messages;
            }).join('\n');
            toast.error(errorMessages);
          } else {
            toast.error("ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบอีกครั้ง");
          }
        } else {
          toast.error(getMessage(res) || "เกิดข้อผิดพลาด");
        }
      }
    });
  };

  useEffect(() => {
    setIsLoading(true);
    getDropdown().then(async () => {
      setIsLoading(false);
    });
  }, [isOpenPopupAddClient]);

  return (
    <FormProvider {...methods}>
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <div className="row">
            <div className="col-9">
              <InputFieldComponent
                name="findWithPhoneRequest.phone"
                mode={InputMode.secondary}
                labelAlignClassName="text-left"
                labelClassName="d-none" // Hide the label to keep it inline
                inputClassName="flex-grow-1" // Allow the input to take remaining space
                renderControl={(field) => (
                  <Input
                    type="text"
                    {...field}
                    className="form-control"
                    autoComplete="off"
                    placeholder="เบอร์โทร"
                    maxLength={15}
                    disabled={isEditTel}
                  />
                )}
              />
            </div>
            <div className="col-3">
              <button
                type="button"
                title="Clipboard"
                className="btn btn-primary me-2 mb-3 w-100" // Add margin to the right for spacing
                onClick={async () => {
                  const isValid = await trigger("findWithPhoneRequest.phone");
                  if (isValid) {
                    await verifyphone(watch());
                  }
                }}
              >
                ตรวจสอบ
              </button>
            </div>
          </div>
          <br />
          {isCreateClient ? (
            <div>
              <div className="row">
                <div className="col-12">
                  <InputFieldComponent
                    name="createTransClientRequest.fullName"
                    mode={InputMode.secondary}
                    label="ชื่อ - นามสกุล"
                    labelAlignClassName="text-left"
                    labelClassName="d-none" // Hide the label to keep it inline
                    inputClassName="flex-grow-1" // Allow the input to take remaining space
                    renderControl={(field) => (
                      <Input
                        type="text"
                        {...field}
                        className="form-control"
                        autoComplete="off"
                        placeholder="ชื่อ - สกุล"
                        maxLength={255}
                      />
                    )}
                  />
                </div>
                <div className="col-12">
                  <InputFieldComponent
                    name="createTransClientRequest.dateOfBirth"
                    label="วัน/เดือน/ปี เกิด"
                    require={true}
                    mode={InputMode.secondary}
                    labelAlignClassName="text-left"
                    labelClassName="col-sm-12"
                    inputClassName="col-sm-12"
                    renderControl={(field) => (
                      <DatePicker
                        {...field}
                        format="dd/MM/yyyy"
                        placeholder="DD/MM/YYYY"
                        editable={false}
                        className="w-100"
                        shouldDisableDate={(date: Date) => date > new Date()}
                        oneTap
                      />
                    )}
                  ></InputFieldComponent>
                </div>
                <div className="col-12">
                  <InputFieldComponent
                    name="createTransClientRequest.gestationalAge"
                    mode={InputMode.secondary}
                    label="อายุครรภ์ (สัปดาห์)"
                    labelAlignClassName="text-left"
                    labelClassName="d-none" // Hide the label to keep it inline
                    inputClassName="flex-grow-1" // Allow the input to take remaining space
                    renderControl={(field) => (
                      <Input
                        type="number"
                        {...field}
                        className="form-control"
                        autoComplete="off"
                        placeholder="อายุครรภ์ (สัปดาห์)"
                      />
                    )}
                  />
                </div>
                <div className="col-12">
                  <InputFieldComponent
                    name="createTransClientRequest.saleRecord"
                    mode={InputMode.secondary}
                    label="บันทึกทีมขาย"
                    labelAlignClassName="text-left"
                    labelClassName="d-none" // Hide the label to keep it inline
                    inputClassName="flex-grow-1" // Allow the input to take remaining space
                    renderControl={(field) => (
                      <Input
                        type="text"
                        {...field}
                        className="form-control"
                        autoComplete="off"
                        placeholder="บันทึกทีมขาย"
                        maxLength={255}
                      />
                    )}
                  />
                </div>
                <div className="col-12">
                  <InputFieldComponent
                    name="createTransClientRequest.receiveServiceDate"
                    label="วันที่เข้ารับบริการ"
                    mode={InputMode.secondary}
                    require={true}
                    labelAlignClassName="text-left"
                    labelClassName="col-sm-12"
                    inputClassName="col-sm-12"
                    renderControl={(field) => (
                      <DatePicker
                        {...field}
                        format="dd/MM/yyyy"
                        placeholder="DD/MM/YYYY"
                        editable={false}
                        className="w-100"
                        shouldDisableDate={(date: Date) => {
                          const today = new Date();
                          today.setHours(0, 0, 0, 0);   
                          return date < today;
                        }}

                        oneTap
                      />
                    )}
                  ></InputFieldComponent>
                </div>
                <div className="col-12">
                  <InputFieldComponent
                    name="createTransClientRequest.tranSaleRefCode"
                    label="เลือกสมาชิกในทีมเพื่อดูแลคนไข้"
                    require={true}
                    mode={InputMode.secondary}
                    labelAlignClassName="text-left"
                    labelClassName="col-sm-12"
                    inputClassName="col-sm-12"
                    renderControl={(field) => (
                      <Select
                        {...field}
                        options={ddlRefCode.map((a) => {
                          return {
                            value: a.value,
                            label: a.labelTh,
                          } as OptionProps;
                        })}
                        onChange={(e) => {
                          const selected = e as OptionProps;
                          resetFieldModal(
                            "createTransClientRequest.tranSaleRefCode"
                          );
                          setValue(
                            "createTransClientRequest.tranSaleRefCode",
                            selected.value
                          );
                        }}
                        value={
                          ddlRefCode
                            .filter((a) => a.value === field.value)
                            ?.map((ct) => {
                              return {
                                value: ct.value,
                                label: ct.labelTh,
                              } as OptionProps;
                            }) || null
                        }
                        isSearchable={true}
                      />
                    )}
                  ></InputFieldComponent>
                </div>
              </div>

              <br />
              <div className="row">
                <div className="col-9"></div>
                <div className="col-3">
                  <button
                    type="button"
                    title="Clipboard"
                    className="btn btn-success me-2 mb-3" // Add margin to the right for spacing
                    onClick={async () => {
                      // Use react-hook-form validation
                      const isValid = await trigger([
                        "createTransClientRequest.dateOfBirth",
                        "createTransClientRequest.receiveServiceDate"
                      ]);

                      if (isValid) {
                        await createClient(watch());
                      }
                    }}
                  >
                    บันทึก
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}
        </>
      )}
      <JsonViewerComponent data={watch()}></JsonViewerComponent>
      <JsonViewerComponent data={errors}></JsonViewerComponent>
    </FormProvider>
  );
};

export default ModalAddClient;
